import { CoSellMsftCreateFormDataId } from '../constants';
import ControlledTextField from '../controlledFields/ControlledTextFieldNew';
import { FieldEnum, memberInputFieldsConfig } from './schema';

const firstName = memberInputFieldsConfig[FieldEnum.firstName];
const lastName = memberInputFieldsConfig[FieldEnum.lastName];
const email = memberInputFieldsConfig[FieldEnum.email];
const phoneNumber = memberInputFieldsConfig[FieldEnum.phoneNumber];

/**
 * This component is used to render a the MemberInput fields
 * If a fieldName is provided, it will be used as a prefix for the field names.
 * otherwise, if this is rendered in its own form, the field names will be used as is
 *
 */
const MemberInputFieldset = ({ fieldName }: { fieldName?: string }) => {
  const fieldNamePrefix = fieldName ? `${fieldName}.` : '';
  return (
    <>
      <ControlledTextField
        dataId={`${CoSellMsftCreateFormDataId.FIELD_PREFIX}-${firstName.name}`}
        name={`${fieldNamePrefix}${FieldEnum.firstName}`}
        label={firstName.label}
        required={firstName.required}
        type={firstName.type}
        helperText={firstName.helperText}
      />
      <ControlledTextField
        dataId={`${CoSellMsftCreateFormDataId.FIELD_PREFIX}-${lastName.name}`}
        name={`${fieldNamePrefix}${FieldEnum.lastName}`}
        helperText={lastName.helperText}
        label={lastName.label}
        required={lastName.required}
        type={lastName.type}
      />
      <ControlledTextField
        dataId={`${CoSellMsftCreateFormDataId.FIELD_PREFIX}-${email.name}`}
        name={`${fieldNamePrefix}${FieldEnum.email}`}
        helperText={email.helperText}
        label={email.label}
        required={email.required}
        type={email.type}
      />
      <ControlledTextField
        dataId={`${CoSellMsftCreateFormDataId.FIELD_PREFIX}-${phoneNumber.name}`}
        name={`${fieldNamePrefix}${FieldEnum.phoneNumber}`}
        helperText={phoneNumber.helperText}
        label={phoneNumber.label}
        required={phoneNumber.required}
        type={phoneNumber.type}
      />
    </>
  );
};

export default MemberInputFieldset;
